import { Outlet, useOutletContext, useParams } from 'react-router-dom'

import { TrainingMembershipFragment } from 'generated/resources/graphql'

import type Employee from 'modules/employees/store/models/Employee'
import { useTrainingsContext } from 'modules/trainings/hooks/Trainings/useTrainingsContext'

const EmployeesTrainingCertificates = () => {
  const { trainingId } = useParams()
  const { trainings } = useTrainingsContext()
  const { employee, trainingMemberships } = useOutletContext<{
    employee: Employee
    trainingMemberships: TrainingMembershipFragment[]
  }>()
  const training = trainings.find((training) => training.id === Number(trainingId))
  const trainingMembership = trainingMemberships.find(
    (membership) =>
      membership.trainingId === Number(trainingId) &&
      membership.accessId === employee.attributes.access_id
  )

  return (
    <Outlet
      context={{ training, employeeAccessId: employee.attributes.access_id, trainingMembership }}
    />
  )
}

export default EmployeesTrainingCertificates
